import { create } from "zustand"
import { DrawerState } from "./types"


const useDrawerStore = create<DrawerState>((set: any, get: any) => ({
	open: false,
	isFullscreen: false,
	setOpen: (value: boolean) => set({ open: value }),
	setFullscreen: (value: boolean) => set({ isFullscreen: value }),
	toggle: () => set({ open: !get().open }),
	toggleFullscreen: () => set({ isFullscreen: !get().isFullscreen }),
	openDrawer: () => set({ open: true }),
	closeDrawer: () => set({ open: false, isFullscreen: false }),
}))

export { useDrawerStore }